/*
  Sister & Sewn: Founding Collection colorway photos.
  - Colorway buttons show a photo of each colorway above its name.
  - Clicking or swiping to a gallery photo of a specific colorway selects that
    colorway, so the item added to the cart always matches the photo shown.
  Only runs when the first option is a colorway (never on Fabric/Sample-only products).
  Data comes from <script data-ss-colorway-data> printed in product-quantity.liquid.
*/
(function () {
  'use strict';
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    var dataEl = document.querySelector('script[data-ss-colorway-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var media = data.media || {};
    var photos = data.photos || {};
    var section = dataEl.closest('[data-section-type="product"]') || document;
    var syncing = false;

    function radios() { return Array.prototype.slice.call(section.querySelectorAll('.js-product-options input[name="option1"]')); }
    function isColorway() {
      var r = radios();
      if (r.length < 2) return false;
      if (!/colou?r/i.test(r[0].getAttribute('data-option') || '')) return false;
      return !r.some(function (i) { return /sample|yard/i.test(i.value); });
    }
    if (!isColorway()) return;
    function current() { var r = radios().filter(function (i) { return i.checked; })[0]; return r ? r.value : null; }
    function labelFor(r) { return section.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(r.id) : r.id) + '"]'); }
    function select(color) {
      var r = radios().filter(function (i) { return i.value === color; })[0];
      if (!r || r.checked) return false;
      var l = labelFor(r);
      (l || r).click();
      return true;
    }
    function decorate() {
      radios().forEach(function (r) {
        var l = labelFor(r);
        if (!l || l.querySelector('.ss-cw-photo')) return;
        var src = photos[r.value];
        if (!src) return;
        var name = l.textContent.trim();
        l.textContent = '';
        l.classList.add('ss-cw');
        var img = document.createElement('img');
        img.className = 'ss-cw-photo';
        img.src = src;
        img.alt = '';
        img.width = 64;
        img.height = 64;
        img.loading = 'lazy';
        var span = document.createElement('span');
        span.className = 'ss-cw-name';
        span.textContent = name;
        l.appendChild(img);
        l.appendChild(span);
      });
    }
    function slides() { return section.querySelectorAll('.js-product-gallery-slide'); }
    function colorAt(i) {
      var s = slides()[i];
      if (!s) return null;
      var w = s.querySelector('[data-media-id]');
      var id = w && w.getAttribute('data-media-id');
      if (!id) return null;
      for (var k in media) {
        if (Object.prototype.hasOwnProperty.call(media, k) && id.indexOf(k) !== -1) return media[k];
      }
      return null;
    }
    function mainSwiper() { var el = section.querySelector('.product-media__slider'); return el && el.swiper; }
    function syncTo(i) {
      var c = colorAt(i);
      if (!c || c === current()) return;
      if (!radios().some(function (r) { return r.value === c; })) return;
      syncing = true;
      select(c);
      setTimeout(function () {
        var sw = mainSwiper();
        if (sw && sw.activeIndex !== i) sw.slideTo(i);
        setTimeout(function () { syncing = false; }, 500);
      }, 700);
    }
    section.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[class*="slider-thumbnails"] .swiper-slide');
      if (!t) return;
      var idx = t.dataset.slideIndex != null ? Number(t.dataset.slideIndex) : Array.prototype.indexOf.call(t.parentNode.children, t);
      syncTo(idx);
    });
    var tries = 0;
    (function hook() {
      var sw = mainSwiper();
      if (sw && sw.on) {
        sw.on('slideChange', function () { if (!syncing) syncTo(sw.activeIndex); });
        return;
      }
      if (++tries < 40) setTimeout(hook, 250);
    })();
    decorate();
    var opts = section.querySelector('.js-product-options');
    if (opts && window.MutationObserver) {
      new MutationObserver(function () { decorate(); }).observe(opts, { childList: true, subtree: true });
    }
  });
})();
